import './Contact.css';

function Contact() {
  return (
    <section id="contacto" className="contact-section py-5">
      <div className="container">

        {/* Título */}
        <div className="text-center mb-5 animate-on-scroll">
          <h6 className="text-primary text-uppercase">CONTÁCTANOS</h6>
          <h2 className="fw-bold">Estamos listos para ayudarte</h2>
          <p className="text-muted fs-5 w-75 mx-auto">
            Ponte en contacto con nosotros y conoce cómo podemos transformar tu proyecto en una realidad digital.
          </p>
        </div>

        {/* Datos de contacto */}
        <div className="row text-center justify-content-center">
          
          <div className="col-md-4 mb-4 animate-on-scroll">
            <div className="p-4 shadow-sm bg-white rounded h-100">
              <i className="bi bi-telephone-fill display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Teléfono</h5>
              <p className="mb-0">+52 1 771 700 8001</p>
            </div>
          </div>

          <div className="col-md-4 mb-4 animate-on-scroll">
            <div className="p-4 shadow-sm bg-white rounded h-100">
              <i className="bi bi-envelope-fill display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Correo Electrónico</h5>
              <p className="mb-0">codenest.dev.projects@gmail.com</p>
            </div>
          </div>

          <div className="col-md-4 mb-4 animate-on-scroll">
            <div className="p-4 shadow-sm bg-white rounded h-100">
              <i className="bi bi-geo-alt-fill display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Ubicación</h5>
              <p className="mb-0">Huejutla de Reyes CP.43000 Hgo.</p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Contact;
